import { type FC, type ReactNode } from "react";

export const CenteredPage: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
    {children}
  </div>
);
